<template>
  <div class="errorpage">
    <!-- <img src="@/assets/images/404.png" alt="" style="margin-top:10%"> -->
    <h1>二维码已过期</h1>
  

  </div>
</template>

<script>
export default {
methods: {
  toHome() {
    this.$router.push("/ship/workbench");
  }
}
};
</script>

<style>
.errorpage {
text-align: center;
}
.errorpage h1 {
margin: 10px;
font-weight: 300;
}
</style>
